if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.setupVariantPickers();
      }

      show(opener) {
        const spinner = opener.querySelector('.loading__spinner');
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
        opener.blur();

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        super.show(opener);

        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      }

      setupVariantPickers() {
        this.querySelectorAll('[data-quick-modal]').forEach((modal) => {
          const variantInput = modal.querySelector('[data-quick-variant-input]');
          const priceEl = modal.querySelector('[data-quick-price]');
          const compareEl = modal.querySelector('[data-quick-compare]');
          const saveEl = modal.querySelector('[data-quick-save]');
          const optionEl = modal.querySelector('[data-quick-selected-option]');
          const imageEl = modal.querySelector('.ferreti-quick-modal__image-tag');
          const submitButton = modal.querySelector('.product-form__submit');
          const buyNowButton = modal.querySelector('[data-quick-buy-now]');

          if (buyNowButton) {
            buyNowButton.addEventListener('click', (e) => {
              e.preventDefault();
              const id = variantInput ? variantInput.value : '';
              const qtyInput = modal.querySelector('.quantity__input');
              const qty = qtyInput ? qtyInput.value : 1;
              if (id) {
                window.location.href = `/cart/${id}:${qty}`;
              }
            });
          }

          modal.querySelectorAll('[data-quick-variant]').forEach((button) => {
            button.addEventListener('click', () => {
              modal.querySelectorAll('[data-quick-variant]').forEach((chip) => chip.classList.remove('is-active'));
              button.classList.add('is-active');

              if (variantInput) variantInput.value = button.dataset.variantId;
              if (optionEl) optionEl.textContent = button.dataset.optionValue || '';
              if (priceEl) priceEl.textContent = button.dataset.price || '';

              if (compareEl) {
                if (button.dataset.compare && button.dataset.compare !== '$0' && button.dataset.compare !== '0') {
                  compareEl.hidden = false;
                  compareEl.textContent = button.dataset.compare;
                } else {
                  compareEl.hidden = true;
                  compareEl.textContent = '';
                }
              }

              if (saveEl) {
                if (button.dataset.save) {
                  saveEl.hidden = false;
                  saveEl.textContent = button.dataset.save;
                } else {
                  saveEl.hidden = true;
                  saveEl.textContent = '';
                }
              }

              if (imageEl && button.dataset.image) {
                imageEl.src = button.dataset.image;
              }

              if (submitButton) {
                const isAvailable = button.dataset.available === 'true';
                submitButton.disabled = !isAvailable;
                const labelEl = submitButton.querySelector('span') || submitButton;
                labelEl.textContent = isAvailable ? 'AGREGAR AL CARRITO' : 'AGOTADO';
                
                if (buyNowButton) {
                  buyNowButton.disabled = !isAvailable;
                  buyNowButton.textContent = isAvailable ? 'COMPRAR AHORA' : 'AGOTADO';
                }
              }
            });
          });
        });
      }
    }
  );
}
